import {Component, Inject} from '@angular/core';
import {MdDialog, MD_DIALOG_DATA} from '@angular/material';
/**
 * \@title Injecting data when opening a dialog
 */
export class DialogDataExample {
/**
 * @param {?} dialog
 */
constructor(public dialog: MdDialog) {}
/**
 * @return {?}
 */
openDialog() {
    this.dialog.open(DialogDataExampleDialog, {
      data: {
        animal: 'panda'
      }
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'dialog-data-example',
  templateUrl: 'dialog-data-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialog, },
];
}

function DialogDataExample_tsickle_Closure_declarations() {
/** @type {?} */
DialogDataExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DialogDataExample.ctorParameters;
/** @type {?} */
DialogDataExample.prototype.dialog;
}

export class DialogDataExampleDialog {
/**
 * @param {?} data
 */
constructor(
public data: any) {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'dialog-data-example-dialog',
  templateUrl: 'dialog-data-example-dialog.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [MD_DIALOG_DATA, ] }, ]},
];
}

function DialogDataExampleDialog_tsickle_Closure_declarations() {
/** @type {?} */
DialogDataExampleDialog.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DialogDataExampleDialog.ctorParameters;
/** @type {?} */
DialogDataExampleDialog.prototype.data;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
